import styled from 'styled-components'
import { themeStyles, themeMedia } from '../../../styles/theme'

export const StyledFallbackFakeSlide = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`

export const StyledSlidesWrapper = styled.div`
  height: 290px;
  width: 100%;
  display: flex;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  color: ${themeStyles.colors.white.main};

  p {
    margin-top: 10px;
  }

  > div {
    position: absolute;
    padding: 1em;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: end;
  }

  ${themeMedia.maxTablet`
    height: 256px;
  `}
  ${themeMedia.maxMobile`
    height: 216px;
  `}
`
